"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Wrapper = _styledComponents.default.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Spinner = ({
  autoPosition,
  colour
}) => {
  const spinnerProps = {
    color: colour
  };

  if (autoPosition) {
    return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, spinnerProps));
  }

  return /*#__PURE__*/_react.default.createElement(_core.CircularProgress, spinnerProps);
};

Spinner.propTypes = {
  autoPosition: _propTypes.default.bool,
  colour: _propTypes.default.string
};
Spinner.defaultProps = {
  autoPosition: true,
  colour: 'primary'
};
var _default = Spinner;
exports.default = _default;